<template>
  <v-select
    @change="handleMetingLocation"
    :items="locations"
    :rules="rules"
    :label="$t('appointment.formCreate.labels.location')"
    item-value="value"
    item-text="label"
    outlined
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'MeetingLocation',

  props: {
    rules: {
      type: Array,
    },

    locations: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters(['branch', 'appointmentFields']),
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),
    ...mapActions(['fetchBranch']),

    handleMetingLocation(value) {
      if (value === 'REAL_ESTATE') {
        this.fetchBranch(this.appointmentFields.real_estate_branch_id)
      }

      this.setAppointmentFields({
        meeting_location_options: {
          meeting_location: value,
        },
      })
    },
  },
}
</script>
